//@ts-nocheck
import { ReactNode } from "react";

import sanitizeHtml from "sanitize-html";

export type SanitizedHtmlProps = {
    readonly innerHTML: string | InnerHTML | ReactNode[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly tagName?: any;
};

export const SanitizedHtml = ({
    innerHTML,
    tagName: Component = "span"
}: SanitizedHtmlProps) => {
    if (typeof innerHTML === "string") {
        return (
            <Component
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(innerHTML) }}
            />
        );
    } else {
        return null;
    }
};
